import React from "react";
import { Instagram, Linkedin, Facebook } from "lucide-react";
import { useLang } from "../LangContext";
import { SOCIALS, IBAN, LOGO_URL } from "../i18n";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="bg-ink border-t border-white/10 px-6 md:px-12 py-16">
            <div className="max-w-7xl mx-auto">
                {/* Contact block (replaces standalone Contact section) */}
                <div id="contact" data-testid="footer-contact" className="border border-white/10 bg-inksurface p-8 md:p-12 mb-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                    <div className="md:col-span-7">
                        <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— {t.contact.label}</span>
                        <h2 className="font-graffiti text-3xl md:text-5xl text-white leading-tight tracking-tight mt-4">
                            {t.contact.title}
                        </h2>
                    </div>
                    <div className="md:col-span-5 flex flex-col gap-3">
                        <a href="mailto:info@urbanrookies.be" data-testid="footer-contact-email" className="btn-volt inline-flex items-center justify-center gap-2 px-6 py-4 text-xs">
                            info@urbanrookies.be →
                        </a>
                        <a href="#donate" className="btn-ghost inline-flex items-center justify-center gap-2 px-6 py-3 text-xs uppercase font-bold tracking-wider">
                            {t.nav.help}
                        </a>
                    </div>
                </div>

                {/* Newsletter strip */}
                <div className="border border-white/10 bg-inksurface p-8 md:p-12 mb-16">
                    <NewsletterSignup />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <img
                            src={LOGO_URL}
                            alt="Urban Rookies by Constant Vanden Stock Foundation"
                            className="logo-invert h-32 md:h-40 w-auto object-contain mb-6"
                        />
                        <p className="font-display font-bold uppercase text-2xl md:text-3xl text-white leading-tight tracking-tight">
                            {t.footer.tagline}
                        </p>
                        <p className="mt-4 text-xs text-zinc-500 font-mono">
                            {t.footer.iban}: {IBAN}
                        </p>
                    </div>
                    <div className="md:col-span-4">
                        <div className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500 mb-4">— Navigate</div>
                        <ul className="space-y-2 text-zinc-300">
                            <li><a href="#mission" className="hover:text-volt">{t.nav.mission}</a></li>
                            <li><a href="#team" className="hover:text-volt">{t.nav.team}</a></li>
                            <li><a href="#inspiration" className="hover:text-volt">{t.nav.inspiration}</a></li>
                            <li><a href="#partners" className="hover:text-volt">{t.nav.partners}</a></li>
                            <li><a href="#program" className="hover:text-volt">{t.nav.program}</a></li>
                            <li><a href="#events" className="hover:text-volt">{t.nav.events}</a></li>
                            <li><a href="#news" className="hover:text-volt">{t.nav.news}</a></li>
                            <li><a href="#donate" className="hover:text-volt">{t.nav.help}</a></li>
                            <li><a href="#contact" className="hover:text-volt">{t.nav.contact}</a></li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <div className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500 mb-4">— Follow</div>
                        <div className="flex gap-3">
                            <a data-testid="social-instagram" href={SOCIALS.instagram} target="_blank" rel="noreferrer" className="w-12 h-12 border border-white/10 hover:border-volt hover:text-volt flex items-center justify-center text-white transition-colors">
                                <Instagram size={18} />
                            </a>
                            <a data-testid="social-linkedin" href={SOCIALS.linkedin} target="_blank" rel="noreferrer" className="w-12 h-12 border border-white/10 hover:border-volt hover:text-volt flex items-center justify-center text-white transition-colors">
                                <Linkedin size={18} />
                            </a>
                            <a data-testid="social-facebook" href={SOCIALS.facebook} target="_blank" rel="noreferrer" className="w-12 h-12 border border-white/10 hover:border-volt hover:text-volt flex items-center justify-center text-white transition-colors">
                                <Facebook size={18} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs text-zinc-600 font-mono">
                        © {new Date().getFullYear()} Urban Rookies VZW / ASBL · {t.footer.rights}
                    </p>
                    <p className="text-xs text-zinc-600 font-mono">Brussels · Belgium</p>
                </div>
            </div>
        </footer>
    );
}
